import { defineMessages } from 'react-intl-next';

export default defineMessages({
	tutorialContentShippingSpeedStatistic: {
		id: 'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic',
		defaultMessage:
			' 76% of Jira Software customers said they shipped projects faster after adding Confluence',
		description: 'Customers statistic on development speed improvement when using Confluence',
	},
	tutorialContentShippingSpeedStatisticSporkRebranding: {
		id: 'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding',
		defaultMessage:
			' 76% of Jira customers said they shipped projects faster after adding Confluence',
		description: 'Customers statistic on development speed improvement when using Confluence',
	},
	tutorialContentGettingStatedTips: {
		id: 'project-pages.improvement.templates.tutorial.content.getting-started-tips',
		defaultMessage: 'Here are a couple of tips to get you started:',
		description: 'Intro text for Confluence tips list',
	},
	tutorialContentConfluenceTemplates: {
		id: 'project-pages.improvement.templates.tutorial.content.confluence-templates',
		defaultMessage:
			'<b>Save time and reduce manual tasks</b>. Confluence has lots of page <a>templates</a>, so you never have to start from scratch. Think technical documents, troubleshooting guides, project plans, product requirements, and more.',
		description: 'Hint on advantages of using Confluence templates',
	},
	tutorialContentEditAndFormat: {
		id: 'project-pages.improvement.templates.tutorial.content.edit-and-format',
		defaultMessage:
			'<b>Easily edit and format.</b> Use the top editing menu for standard word formatting, and by typing <b>/</b> you can easily insert lots of handy integrations. Insert a table by typing <c>/table</c> or an image with <c>/image</c>. You can also insert Dropbox links <c>/dropbox</c>, Microsoft office tools <c>/microsoft</c>, or Trello boards and cards <c>/trello</c>.',
		description: 'Hint for info on editing and formatting Confluence documents',
	},
	tutorialContentSpacesAndPages: {
		id: 'project-pages.improvement.templates.tutorial.content.spaces-and-pages',
		defaultMessage:
			'<b>Using spaces and pages</b>. Spaces are part of every Confluence site and are a way of organizing pages into categories. Think of spaces as different folders or projects, and pages are the documents that belong in those folders or projects. <a>Learn more about how to use spaces</a>',
		description: 'Hint for info on Confluence spaces',
	},
	tutorialContentJiraAndConfluence: {
		id: 'project-pages.improvement.templates.tutorial.content.jira-and-confluence',
		defaultMessage: ' Use Jira and Confluence together',
		description: 'Title of Jira and Confluence integrations section',
	},
	tutorialContentJiraLinks: {
		id: 'project-pages.improvement.templates.tutorial.content.jira-links',
		defaultMessage:
			'Link a Jira issue anywhere on your page. The link on the page will update in real-time, as you update the Jira issue. Type <c>/Jira</c>.',
		description: 'Description of links to Jira in Confluence',
	},
	tutorialContentJiraRoadmaps: {
		id: 'project-pages.improvement.templates.tutorial.content.jira-roadmaps',
		defaultMessage:
			'Embed interactive roadmaps and timelines for your page using your Jira Projects. Type <c>/jira roadmap</c>.',
		description: 'Description of Jira roadmaps slash command',
	},
	tutorialContentJiraTimeline: {
		id: 'project-pages.improvement.templates.tutorial.content.jira-timeline',
		defaultMessage:
			'Embed interactive timelines for your page using your Jira Projects. Type <c>/jira timeline</c>.',
		description: 'Description of Jira timeline slash command',
	},
	tutorialContentJiraCharts: {
		id: 'project-pages.improvement.templates.tutorial.content.jira-charts',
		defaultMessage: 'Create charts on your pages using real Jira data. Type <c>/Jira charts</c>.',
		description: 'Description of Jira charts slash command',
	},
	tutorialContentTryItNow: {
		id: 'project-pages.improvement.templates.tutorial.content.try-it-now',
		defaultMessage: 'Try it now ',
		description: 'Call to action at the bottom the tutorial template',
	},
	tutorialContentForwardSlashPrompt: {
		id: 'project-pages.improvement.templates.tutorial.content.forward-slash-prompt',
		defaultMessage: 'Type / followed by ‘table’ or ‘image’',
		description: 'Placeholder text detailing how to use Confluence slash commands',
	},
	tutorialContentHandyLinks: {
		id: 'project-pages.improvement.templates.tutorial.content.handy-links',
		defaultMessage: ' Handy links',
		description: 'Title of section with links to guides and videos',
	},
});
